import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Parametro } from './models/parametrizacao';

@Injectable({
    providedIn: 'root'
})

export class ParametrizacaoService {

    private environmentUrl: string = '';

    constructor(private httpClient: HttpClient) { this.environmentUrl = environment.ApiCore; }

    getParametros(): Observable<Parametro[]> {
        let url = this.environmentUrl + "/parametro/";
        return this.httpClient.get<Parametro[]>(url);
    }

    getParametrosEvento(idEvento: number): Observable<Parametro[]> {
        let url = this.environmentUrl + "/parametro/-/evento/"+idEvento;
        return this.httpClient.get<Parametro[]>(url);
    }


    getParametro(idParametro: number): Observable<Parametro> {
        let url = this.environmentUrl + "/parametro/" + idParametro.toString();
        return this.httpClient.get<Parametro>(url);
    }

    addParametro(parametro: Parametro) {
        return this.httpClient.post(this.environmentUrl + "/parametro", parametro);
    }

    updParametro(parametro: Parametro) {
        return this.httpClient.put(this.environmentUrl + "/parametro", parametro);
    }

    delParametro(idParametro: number) {
        return this.httpClient.delete(this.environmentUrl + "/parametro/" + idParametro.toString());
    }
}